import { Menu, Image, Tooltip, Row, Col } from 'antd';
import {
  CheckOutlined,
  ApartmentOutlined,
  LoadingOutlined
} from '@ant-design/icons';
import {
  DecodeCurrentUser,
  GetAboutAccountURL,
  GetHelpSupportURL,
  getInitials,
  GetMekariURL,
  GetPrivacyURL,
  GetTalentaURL,
  GetTermsUseURL,
} from 'Helpers';
import { setCurrentCompany, signOutAuth } from 'Actions/User';
import { useDispatch } from 'react-redux';

const { SubMenu } = Menu;

const currentUser = JSON.parse(DecodeCurrentUser())?.current_user;
const consultants = JSON.parse(DecodeCurrentUser())?.consultants;
const currentCompany = JSON.parse(DecodeCurrentUser())?.current_company;
const defaultCompany = JSON.parse(DecodeCurrentUser())?.default_company;

const NavbarWrap = () => {
  if (!currentUser) {
    return '';
  }

  const dispatch = useDispatch();
  const onSelectCompany = (e) => {
    if (Number(currentCompany.company.id) === Number(e.key)) {
      return false;
    }

    e.domEvent.target.parentElement.querySelector('.loading-menu-company').classList.remove('hide');
    return dispatch(setCurrentCompany(Number(e.key)));
  }

  const onSignout = (e) => {
    e.domEvent.target.parentElement.querySelector('.loading-sign-out').classList.remove('hide');
    return dispatch(signOutAuth());
  }

  return (
    <Menu mode="inline">
      <SubMenu
        key="avatar"
        className='avatar-menu'
        title={
          <Tooltip title={`${currentUser.first_name} ${currentUser.last_name}`} placement='bottom' className='nav-menu'>
            {!currentUser?.avatar ? (
              <div className='initial-name'>
                {getInitials(`${currentUser.first_name} ${currentUser.last_name}`)}
              </div>
            ) : <Image src={currentUser.avatar} preview={false} />}
          </Tooltip>
        }
      >
        <Menu.Item key="short-profile" className='short-profile-menu'>
          <Row className='header-section-menu'>
            <Col span={24} className='user-avatar'>
              {!currentUser.avatar ? (
                <div className='initial-name'>
                  {getInitials(`${currentUser.first_name} ${currentUser.last_name}`)}
                </div>
              ):(<Image src={currentUser.avatar} />)}
            </Col>

            <Col span={24} className='user-info'>
              <div className='user-name'>
                <Tooltip title={`${currentUser.first_name} ${currentUser.last_name}`} placement='left'>
                  <strong>
                    {`${currentUser.first_name} ${currentUser.last_name}`}
                  </strong>
                </Tooltip>
              </div>
              <div className='company-name'>
                <Tooltip title={currentCompany.company.name} placement='left'>
                  {currentCompany.company.name}
                </Tooltip>
              </div>
            </Col>
          </Row>
        </Menu.Item>

        <SubMenu key="company-list" title="Company List" className='company-list-sub-menu'>
          <Menu.Item key={defaultCompany.company.id} onClick={onSelectCompany}>
            <ApartmentOutlined className='company-icon' />
            <Tooltip title={defaultCompany.company.name} placement='left'>
              <div className='company-name'>{defaultCompany.company.name}</div>
            </Tooltip>
            {Number(currentCompany.company.id) === Number(defaultCompany.company.id) && (
              <CheckOutlined className='select-company' />
            )}
            <LoadingOutlined className='loading-menu-company hide' />
          </Menu.Item>
          {consultants.map(consul => (
            consul.company.id !== defaultCompany.company.id && (
              <>
                <Menu.Item key={consul.company.id} onClick={onSelectCompany}>
                  <ApartmentOutlined className='company-icon' />
                  <Tooltip title={consul.company.name} placement='left'>
                    <div className='company-name'>{consul.company.name}</div>
                  </Tooltip>
                  {Number(consul.company.id) === Number(currentCompany.company.id) && (
                    <CheckOutlined className='select-company' />
                  )}
                  <LoadingOutlined className='loading-menu-company hide' />
                </Menu.Item>
              </>
            ))
          )}
        </SubMenu>
        <Menu.Item key="help-support" className='help-support-menu'>
          <a href={GetHelpSupportURL()} target="_blank" rel="noreferrer">Help & Support</a>
        </Menu.Item>
        <Menu.Item key="back-talenta" className='back-talenta-menu'>
          <a href={GetTalentaURL()} target="_blank" rel="noreferrer">Back to Talenta</a>
        </Menu.Item>
        <Menu.Item key="signout" className='sign-out-menu' onClick={onSignout}>
          Sign out
          <LoadingOutlined className='loading-sign-out hide' />
        </Menu.Item>
        <div className='footer-navbar'>
          <span className='left'>
            <a href={GetPrivacyURL()} target="_blank" rel="noreferrer"><small>Privacy</small></a>
          </span>
          <span className='center'>
            <a href={GetTermsUseURL()} target="_blank" rel="noreferrer"><small>Term of Use</small></a>
          </span>
          <span className='right'>
            <a href={GetAboutAccountURL()} target="_blank" rel="noreferrer"><small>About Mekari Account</small></a>
          </span>
        </div>
        <div className='footer-navbar-copyright'>
          <a href={GetMekariURL()} target="_blank" rel="noreferrer"><small>Mekari &copy; 2022</small></a>
        </div>
      </SubMenu>
    </Menu>
  );
}

export default NavbarWrap;
